class ProgressBar {
  constructor(options) {}

  static updateProgress(value) {
    const components = document.getElementsByClassName("progress-bar-complete");
    if (!components) return;
    const component = components[0];
    if (!component) return;

    component.style.width = value + "%";
  }
}

module.exports = ProgressBar;
